// extracted by mini-css-extract-plugin
export default {"viewer":"d7iV1V9roCkEVBirnBev"};